
import React, { useState } from 'react';
import { Dialog, DialogContent } from '@/components/ui/dialog';
import ReceiptsEditForm from '@/components/receipts/ReceiptsEditForm';
import ReceiptsCreationFlow from '@/components/receipts/ReceiptsCreationFlow';

const ReceiptsForm = ({ isOpen, onClose, onSave, onSavePlatformAdjustments, operators, receipt, onUpdate, flags, paymentMethods }) => {
  const isEditMode = !!receipt;
  const [step, setStep] = useState(1);
  const [selectedOperator, setSelectedOperator] = useState(null);

  const handleOpenChange = (open) => {
    if (!open) {
      setStep(1);
      setSelectedOperator(null);
      onClose();
    }
  };

  if (isEditMode) {
    return (
      <Dialog open={isOpen} onOpenChange={handleOpenChange}>
        <DialogContent className="max-w-lg">
          <ReceiptsEditForm 
            receipt={receipt}
            onUpdate={onUpdate}
            onClose={onClose}
            operators={operators}
            flags={flags}
            paymentMethods={paymentMethods}
          />
        </DialogContent>
      </Dialog>
    );
  }

  const contentClassName = step === 1 ? undefined : "max-w-7xl w-[90vw] h-[90vh] flex flex-col";

  return (
    <Dialog open={isOpen} onOpenChange={handleOpenChange}>
      <DialogContent className={contentClassName}>
        <ReceiptsCreationFlow 
          onSave={onSave}
          onSavePlatformAdjustments={onSavePlatformAdjustments}
          onClose={onClose}
          operators={operators}
          step={step}
          setStep={setStep}
          selectedOperator={selectedOperator}
          setSelectedOperator={setSelectedOperator}
        />
      </DialogContent>
    </Dialog>
  );
};

export default ReceiptsForm;
